var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"customer-navigation"},_vm._l((_vm.links),function(link,key){return _c('router-link',{key:key,attrs:{"to":link},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isExactActive = ref.isExactActive;
return [_c('li',{class:[isExactActive && 'active', 'customer-navigation-item']},[_c('a',{attrs:{"href":href},domProps:{"textContent":_vm._s(route.name)},on:{"click":navigate}})])]}}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }